const setting = {
    title: '中国中化招聘官网',
    domain: 'https://sinochem.hotjob.cn',
    suiteKey: 'SU610b91ee0dcad4106ff11c21',
    ClientId: 'zhonghua-web',
    platform: '2',
    isSetGray: false // 是否置灰(例如:国家公祭日)
}

export default setting